<template>
    <layout title="Cottonseed Tickets">
        <div class="px-8">
            <cottonseed-listings :items="items"></cottonseed-listings>
        </div>
    </layout>
</template>

<script>

import Layout from "@/Shared/Layout";
import CottonseedListings from "@/Components/CottonseedTickets/CottonseedListings";

export default {
    components: {CottonseedListings, Layout},
    props: {
        items: {
            type: Array,
            default: []
        },
    },
}
</script>
